/* News 記事の本文にある動きのある部品（2026-10-13）— templates/article.liquid から読み込む
 *
 * 旧サイト（WordPress）では記事の本文にスクリプトを直書きしていたが、移行時に本文のスクリプトは外したため動いていなかった。
 * 同じ動きをここで行う（元のスクリプトは旧サーバーの記事 gift-2 から取得。動きは元のまま）。
 *   1. 予算タブ（.kj-pt-tab / .kj-pt-panel）: タブを押すと対応するパネルに切り替える
 *   2. 「なぜKINUJO」欄（.kj-why-*）: 見出しを押すと開閉／横スクロールのギャラリーにスクロールバー／
 *      画像を押すと拡大表示し、data-products の商品へのリンクを出す（拡大表示の枠 #kjLightbox は移行で抜けたので、無ければ作る）
 * パスワード付きの記事は、正しいパスワードで本文が出たとき（kj:article-open）に動かす
 */
(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('.kj-pt-tab');
    tabs.forEach(function (btn) {
      if (btn.dataset.kjInit) return;
      btn.dataset.kjInit = '1';
      btn.addEventListener('click', function () {
        root.querySelectorAll('.kj-pt-tab').forEach(function (b) { b.classList.remove('active'); });
        root.querySelectorAll('.kj-pt-panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = document.getElementById(btn.dataset.tab);
        if (panel) panel.classList.add('active');
      });
    });
  }

  function ensureLightbox() {
    var box = document.getElementById('kjLightbox');
    if (!box) {
      box = document.createElement('div');
      box.className = 'kj-lightbox';
      box.id = 'kjLightbox';
      box.innerHTML =
        '<button class="kj-lightbox-prev" id="kjLightboxPrev" type="button">&lsaquo;</button>' +
        '<button class="kj-lightbox-next" id="kjLightboxNext" type="button">&rsaquo;</button>' +
        '<div class="kj-lightbox-card">' +
        '<button class="kj-lightbox-close" id="kjLightboxClose" type="button">&times;</button>' +
        '<div class="kj-lightbox-inner" id="kjLightboxInner"></div>' +
        '<p class="kj-lightbox-products-label" id="kjLightboxProductsLabel">PICK UP ITEM</p>' +
        '<div class="kj-lightbox-products" id="kjLightboxProducts"></div>' +
        '</div>';
    }
    if (box.parentElement !== document.body) document.body.appendChild(box);
    return box;
  }

  function initWhy(root) {
    root.querySelectorAll('.kj-why-toggle-head').forEach(function (h) {
      if (h.dataset.kjInit) return;
      h.dataset.kjInit = '1';
      h.addEventListener('click', function () {
        var toggle = h.parentElement;
        var body = toggle.querySelector('.kj-why-toggle-body');
        var isOpen = toggle.classList.toggle('open');
        if (body) body.style.maxHeight = isOpen ? (body.scrollHeight + 'px') : '0px';
      });
    });

    root.querySelectorAll('.kj-why-gallery').forEach(function (g) {
      if (g.dataset.kjInit) return;
      g.dataset.kjInit = '1';
      var bar = g.nextElementSibling;
      if (!bar || !bar.classList.contains('kj-why-gallery-bar')) return;
      var thumb = bar.querySelector('.kj-why-gallery-bar-thumb');
      if (!thumb) return;
      function update() {
        var ratio = g.clientWidth / g.scrollWidth;
        thumb.style.width = (ratio * 100) + '%';
        var maxScroll = g.scrollWidth - g.clientWidth;
        var scrollRatio = maxScroll > 0 ? g.scrollLeft / maxScroll : 0;
        thumb.style.left = (scrollRatio * (100 - ratio * 100)) + '%';
      }
      g.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });

    var galleries = root.querySelectorAll('.kj-why-gallery');
    if (!galleries.length) return;
    var box = ensureLightbox();
    var inner = document.getElementById('kjLightboxInner');
    var products = document.getElementById('kjLightboxProducts');
    var label = document.getElementById('kjLightboxProductsLabel');
    var items = [];
    var index = 0;

    function show(i) {
      var total = items.length;
      index = (i + total) % total;
      var item = items[index];
      var img = item.querySelector('img');
      inner.innerHTML = '';
      if (img) {
        var big = document.createElement('img');
        big.src = img.src;
        big.alt = img.alt || '';
        big.style.width = '100%';
        big.style.height = '100%';
        big.style.objectFit = 'cover';
        big.style.display = 'block';
        inner.appendChild(big);
      } else {
        inner.textContent = item.textContent;
      }
      products.innerHTML = '';
      var list = [];
      try { list = JSON.parse(item.getAttribute('data-products') || '[]'); } catch (e) { list = []; }
      list.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'kj-lightbox-product';
        a.href = p.url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = p.name;
        products.appendChild(a);
      });
      if (label) label.style.display = list.length ? '' : 'none';
    }

    galleries.forEach(function (gallery) {
      var spans = Array.prototype.slice.call(gallery.querySelectorAll('span'));
      spans.forEach(function (item, i) {
        if (item.dataset.kjInit) return;
        item.dataset.kjInit = '1';
        item.addEventListener('click', function () {
          items = spans;
          show(i);
          box.classList.add('open');
        });
      });
    });

    if (!box.dataset.kjInit) {
      box.dataset.kjInit = '1';
      document.getElementById('kjLightboxPrev').addEventListener('click', function () { show(index - 1); });
      document.getElementById('kjLightboxNext').addEventListener('click', function () { show(index + 1); });
      document.getElementById('kjLightboxClose').addEventListener('click', function () { box.classList.remove('open'); });
      box.addEventListener('click', function (e) { if (e.target === box) box.classList.remove('open'); });
    }
  }

  function init() {
    // アプリ（Smart Agent Blog）の本文（#smart-blog-article-content）があればそちらを優先（2026-10-15・article.smart-gift）
    var root = document.getElementById('smart-blog-article-content') || document.querySelector('.page-news-details .content__inner');
    if (!root) return;
    initTabs(root);
    initWhy(root);
  }

  document.addEventListener('kj:article-open', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
